export const environment = {
  production: false,
  url: "https://bbeatz-api-maincms-staging.stacknize.com/cms/",
  httpMethod: 'https://',
  id: 100100
};

